import { useContext } from 'react';
import { FlagContext } from '../contexts/flag';
var useSettings = function useSettings() {
  var _useContext = useContext(FlagContext),
    settings = _useContext.settings;
  return settings;
};
export default useSettings;